import { PublicUserResponse } from "./response/public-user.response";
import { Like } from './like';
import { Product } from './product';

export class UserTweet
{
    id: number;
    tweet: string;

    createdDate: string;

    publicUserResponse: PublicUserResponse;
    likes: Like[];
    children: UserTweet[];

    parentId?: number;
    Parent: UserTweet;

    productId?: number;
    product: Product;

}